import { AxiosResponse } from "axios";
import { api } from "../api";
import { IPost, IPostPreview, IPostResponse } from "../interfaces/posts";

export class PostService {

    async post (payload: any): Promise<IPost> {
        return await api.post(`/posts`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((res: AxiosResponse<IPost>) => res.data)
        .catch((error) => error);
    }

    async get_three () {
        return await api.get("/posts/three")
        .then((res: AxiosResponse<IPostPreview[]>) => res)
        .catch(error => error)
    }
    async get_all (page?: number, limit?: number, category?: string): Promise<IPostResponse> {
        return await api.get("/posts", {
            params: {
                page,
                limit,
                category 
            }
        })
        .then((res: AxiosResponse<IPostResponse>) => res.data)
        .catch(error => error)
    }
    async get_one (indentificador: string) {
        return await api.get(`/posts/${indentificador}`)
        .then((res: AxiosResponse<IPost>) => res.data)
        .catch(error => error)
    }
    async delete (id: string): Promise<AxiosResponse> {
        return await api.delete(`/posts/${id}`)
        .then((res: AxiosResponse<any>) => res)
        .catch(error => error)
    }
    
}